import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Card from '@/modules/common/components/Card';
import Button from '@/modules/common/components/Button';
import Spinner from '@/modules/common/components/Spinner';
import ChipLink from '@/modules/common/components/ChipLink';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import DialogChangePassword from '@/modules/common/components/DialogChangePassword';
import { getUserType, formatDateTime } from '~/common';

const Information = (props) => {
    const [openDialogChangePassword, setOpenDialogChangePassword] = useState(false);

    // noinspection JSUnresolvedVariable
    return (
        <Card id="profile-information">
            <CardHeader title="Детальная информация"/>
            <CardContent className={(props.loading) ? 'loading' : ''}>
                {(!props.loading)
                    ? <>
                        {(props.user)
                            ? <>
                                <div className="left">
                                    <AccountCircleIcon/>
                                    <Button onClick={() => setOpenDialogChangePassword(true)}>
                                        Изменить пароль
                                    </Button>
                                </div>
                                <div className="right">
                                    <Typography>Имя пользователя: {props.user.username}</Typography>
                                    {(!props.auth.user.affiliate)
                                        ? <Typography>Тип пользователя: {getUserType(props.user.user_type)}</Typography>
                                        : null
                                    }
                                    {(props.user.last_login)
                                        ? <Typography>
                                            Последний вход: {formatDateTime(new Date(props.user.last_login))}
                                        </Typography>
                                        : null
                                    }
                                    {(props.user.affiliate)
                                        ? <>
                                            <Typography>
                                                Название партнера: {props.user.affiliate.affiliate_name}
                                            </Typography>
                                            <Typography>ID партнера: {props.user.affiliate.affiliate_id}</Typography>
                                            <div id="related">
                                                {(props.user.affiliate.related_count.leads)
                                                    ? <ChipLink label={`Лиды: ${props.user.affiliate.related_count.leads}`}
                                                                to={`/leads/?affiliate_name=${props.user.affiliate.affiliate_name}`}
                                                    />
                                                    : null
                                                }
                                                {(!props.auth.user.affiliate)
                                                    ? <>
                                                        <ChipLink
                                                            label={`PostBack'и: ${props.user.affiliate.related_count.postbacks}`}
                                                            to={`/users/${props.user.username}/postbacks/`}
                                                        />
                                                        <ChipLink
                                                            label={`Цены: ${props.user.affiliate.related_count.prices}`}
                                                            to={`/users/${props.user.username}/prices/`}
                                                        />
                                                    </>
                                                    : null
                                                }
                                            </div>
                                        </>
                                        : null
                                    }
                                    {(props.user.client)
                                        ? <>
                                            <Typography>
                                                Оффер:{' '}
                                                <Link to={`/offers/${props.user.client.offer.offer_name}`}>
                                                    {props.user.client.offer.offer_name}
                                                </Link>
                                            </Typography>
                                        </>
                                        : null
                                    }
                                </div>
                                <DialogChangePassword username={props.user.username}
                                                      open={openDialogChangePassword}
                                                      setOpen={setOpenDialogChangePassword}
                                />
                            </>
                            : <ErrorFetch onClick={() => props.fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </CardContent>
        </Card>
    );
};

Information.propTypes = {
    loading: PropTypes.bool.isRequired,
    user: PropTypes.object,
    fetch: PropTypes.func.isRequired,
};

export default connect(
    (state) => ({
        auth: state.auth,
    }),
    null
)(Information);
